import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useStore, useStorePersist} from "store/context";

import { UnidadService } from 'services/UnidadService';
import useRequest from 'hooks/useRequest';

import GradientButton from '../../../components/atoms/GradientButton';
import MainLayout from '../../../components/Layouts/MainLayout';
import InputText from '../../../components/atoms/InputText';

import Box from '../../../components/atoms/Box';
import Table from 'react-bootstrap/Table'

import UnidadRow from 'views/UnidadFacturacion/UnidadesAdheridas/UnidadRow';
import Modal from 'components/atoms/Modal';

import './styles.scss';

const UnidadesAdheridasView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const [{
        uf,  // La uf actual seleccionada
    }, dispatch] = useStore();
    
    const [{
        unidades,  // El listado de las unidades
    }, dispatchPersist] = useStorePersist();

    const [unidad, setUnidad] = useState([]);

    const [show, setShow] = useState(false);

    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");

    const handleShow = () => {
        console.log('opem');
        setShow(true);
    }

    const handleClose = () => {
        console.log('close');
        setShow(false);
    }

    useEffect(() => {
        if (!unidades || unidades.length === 0) {
            console.log('BUSCAR UNIDADES');
            getUnidades();
        }
        var wrapper1 = document.getElementById('wrapper1');
        var wrapper2 = document.getElementsByClassName('table-responsive')[0];
        var table = wrapper2.querySelector('.table');
        document.getElementById("div1").style.width = table.offsetWidth;

        wrapper1.onscroll = function () {
            console.log('wrapper1');
            wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function () {
            console.log('wrapper2');
            wrapper1.scrollLeft = wrapper2.scrollLeft;
        };
    }, []);

    useEffect(() => {
        if (unidades && unidades.length > 0 && !uf) {
            console.log('useEffect de unidades');
            beforeSubmit();
            dispatch({
                type: 'setUf',
                payload: unidades[0],
            });
            afterSubmit();
        }
    }, [unidades]);

    const getUnidades = () => {
        beforeSubmit();
        UnidadService.unidades({})
            .then((unidades) => {
                
                dispatchPersist({
                    type: 'setUnidades',
                    payload: unidades
                });
                
                afterSubmit();
                if (unidades.length === 0) {
                    history.push('/unidades_adheridas');
                    return;
                }
            }).catch((error) => {
                afterSubmit();
            });
    }

    const desvincularConfirm = (unidad) => {
        setUnidad(unidad);
        console.log("abro popup y preparo");
        setTitle(<><strong>UF {unidad.unidad}</strong><br></br>{unidad.direccion}</>);
        setBody("¿Realmente querés desvincular esta Unidad de Facturación?");
        handleShow();
        //
        // ABRIR POP UP
        // LUEGO LLAMAR A DESVINCULAR
        //
    }

    const desvincular = () => {
        beforeSubmit();
        UnidadService.desvincular(unidad.id)
            .then(data => {
                afterSubmit();
                handleClose();
                dispatch({
                    type: 'resetUnidades',
                    payload: {},
                });
                dispatchPersist({
                    type: 'resetUnidadesPersist',
                    payload: {},
                });
                getUnidades();
            }).catch((error) => {
                dealWithError(error, 'No se ha podido desvincular la unidad de facturacion');
            });
    }

    const vincular = (e) => {
        e.preventDefault();
        history.push('/vincular');
    }

    const fidelizar = (unidad) => {
 
        history.push(`/fidelizar/${unidad.id}`);
    }

    return (<>
        <MainLayout>
            <Box header="UNIDADES VINCULADAS" body={<div className="unidades-adheridas-boxes">
                <div className="unidades-adheridas-button">
                    <GradientButton legend={'+ VINCULAR UNIDAD DE FACTURACIÓN'}
                        handleClick={vincular}/>
                </div>
                <p className="aclaracion">Tené a mano la factura del servicio para completar los datos solicitados</p>
                <div id="wrapper1">
                    <div id="div1">
                    </div>
                </div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>UNIDAD DE FACTURACIÓN</th>
                            <th>ALIAS</th>
                            <th>PARTIDO/PARTIDA</th>
                            <th>RAZÓN SOCIAL</th>
                            <th>DIRECCIÓN DEL INMUEBLE</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        { unidades.map(( u ) => 
                            <UnidadRow key={u.id} {...u}
                              desvincularConfirm={() => desvincularConfirm(u)}
                              fidelizar={() => fidelizar(u)}
                            />
                        )}
                        {(unidades.length === 0 && !submitted) &&
                            <tr>
                                <td colSpan="6" align="center">No tiene unidades de facturación vinculadas</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
            }>
            </Box>
        </MainLayout>
        <Modal title={title} body={body} legend="DESVINCULAR" footer="No implica baja de Factura Digital y Débito Automático" action={desvincular} handleClose={handleClose} show={show}></Modal>
        </>
    );
}

export default withTranslation()(UnidadesAdheridasView);